import { formatFullDateTime, formatTime } from "../lib/date";
import type { BookingConfirmation, PublicBookingPage } from "../lib/types";

type Props = {
  page?: PublicBookingPage | undefined;
  startAt?: string | null | undefined;
  booking?: BookingConfirmation;
  viewerTimeZone: string;
  compact?: boolean;
};

export function BookingDocket({ page, startAt, booking, viewerTimeZone, compact = false }: Props) {
  const starts = booking?.starts_at ?? startAt;
  const host = booking?.host_name ?? page?.host.display_name ?? "Choose a host";
  const title = booking?.title ?? page?.event_type.title ?? "30-minute working session";
  const duration = page?.event_type.duration_minutes ?? (booking ? Math.round((new Date(booking.ends_at).getTime() - new Date(booking.starts_at).getTime()) / 60_000) : 30);

  return (
    <article className={`docket${compact ? " docket--compact" : ""}`} aria-label="Appointment summary">
      <div className="docket__cut" aria-hidden="true" />
      <p className="docket__eyebrow">Appointment docket</p>
      <p className="docket__time">
        {starts ? formatFullDateTime(starts, viewerTimeZone) : "Select a date and time"}
      </p>
      {starts && viewerTimeZone !== "Africa/Johannesburg" ? (
        <p className="docket__sast">{formatTime(starts, "Africa/Johannesburg")} SAST</p>
      ) : null}
      <div className="docket__rule" />
      <p className="docket__title">{title}</p>
      <p className="docket__host">{host}</p>
      <div className="docket__meta">
        <span>{duration} min</span>
        <span>{page?.event_type.location_label ?? booking?.location_label ?? "Online"}</span>
      </div>
    </article>
  );
}
